import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const CREATE_TEST_CONFIG = enabledOn(PlatformSlug.INBDEBooster, PlatformSlug.NBDHEBooster)

export const isCreateTestAvailable = (slug?: PlatformSlug) => isFeatureAvailable(CREATE_TEST_CONFIG, slug)
